import { Lock } from "lucide-react";
import { trpc } from "@/lib/trpc";

/** Selo ao lado do mês escolhido quando ele já foi fechado. */
export function MesFechado({ competencia }: { competencia: string }) {
  const meses = trpc.financeiro.fechamento.listar.useQuery().data;
  if (!meses?.some((m) => m.competencia === competencia && m.fechamento)) return null;
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-zinc-100 px-2.5 py-1 text-xs font-semibold text-zinc-600 dark:bg-muted dark:text-muted-foreground">
      <Lock className="h-3 w-3" /> Fechado
    </span>
  );
}
